import React, { useState, useEffect } from 'react';
import dynamic from 'next/dynamic';
import { List, ListItem, useDisclosure } from '@thebouqs/ui';
// TODO: export Collapse from Bouqs UI
import { Collapse } from '@chakra-ui/transition';
import { AddIcon, MinusIcon } from '@thebouqs/icons';
import useTranslation from '@/hooks/useTranslation';
import { SFErrorBoundary } from '@/components/ErrorBoundary';
import MenuItemErrorFallback from '@/components/TopNav/MenuItemErrorFallback';
import { SubMenuProps } from './SubMenu.d';

const MenuLink = dynamic(import('@/components/TopNav/DrawerMenu/MenuLink'));

const SubMenu = ({
  new_section,
  subMenuLinks,
  topLinkIndex,
  topLinkName,
}: SubMenuProps): JSX.Element => {
  const { getButtonProps, getDisclosureProps, isOpen, onToggle } =
    useDisclosure({ id: `drawer-menu-item-${topLinkIndex}-submenu` });
  const { t } = useTranslation();

  return (
    topLinkName && (
      <SFErrorBoundary
        fallbackComponent={<MenuItemErrorFallback />}
        targetComponent="DrawerMenu SubMenu">
        <button
          onClick={onToggle}
          className={`drawer-menu__item drawer-menu__item--top drawer-menu__item--link drawer-menu__item--trigger ${
            new_section ? 'drawer-menu__item--section-divider' : ''
          }`}
          {...getButtonProps()}
          aria-expanded={isOpen}
          aria-label={t('aria.label.toggleSubmenu', { name: topLinkName })}>
          {topLinkName}
          <span className="drawer-menu__toggle">
            {isOpen ? (
              <MinusIcon boxSize="4" color="primary" />
            ) : (
              <AddIcon boxSize="4" color="primary" />
            )}
          </span>
        </button>
        <Collapse in={isOpen} unmountOnExit={true}>
          <List className="drawer-menu-submenu" {...getDisclosureProps()}>
            {subMenuLinks.map((item, index) => {
              return (
                item && (
                  <ListItem
                    key={`drawer-menu-item-${topLinkIndex}-submenu-item-${index}`}
                    data-testid={`drawer-menu-item-${topLinkIndex}-submenu-item-${index}`}>
                    <MenuLink variant="sub" data={item} />
                  </ListItem>
                )
              );
            })}
          </List>
        </Collapse>
      </SFErrorBoundary>
    )
  );
};

export default SubMenu;
